module.exports = __webpack_public_path__ + "media/images/crosswords/pos1-e68f8c6e0626b031ce4172a28ef6fc42.png";